import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';

@Component({
	selector: 'ras-free-move-page',
	templateUrl: './free-move-page.component.html',
	styleUrls: ['./free-move-page.component.sass']
})
export class FreeMovePageComponent implements OnInit {

	constructor(private meta: MetaService) { }

	ngOnInit() {
		this.meta.apply('free-move-in-transport')
	}

}
